import { NotionProps } from 'notion/types';
import ColorChart from 'organisms/ColorChart';
import { ColorChartVariants } from 'organisms/ColorChart/useColorChart';

const NotionColorChart: React.FC<NotionProps> = ({ block: { variant } }) => (
  <ColorChart variant={variant as ColorChartVariants} />
);

export default NotionColorChart;
